import type { FormGroupProps } from '@ksyos/design-system/dist/components/form-group';

export type OmittedFormGroupFieldProps = Omit<FormGroupProps, 'children' | 'onChange'>;

export function computeFormGroupProps({
    hasErrors,
    htmlFor,
    isLabelSensitiveData,
    isRequired,
    label,
    labelAvatar,
    layout,
    tooltipText,
}: OmittedFormGroupFieldProps): OmittedFormGroupFieldProps {
    return {
        hasErrors,
        htmlFor,
        isLabelSensitiveData,
        isRequired,
        label,
        labelAvatar,
        layout,
        tooltipText,
    };
}
